// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1OUH3","noInteraction":"EventWrapper_noInteraction__3F8Hc","pointerPassthrough":"EventWrapper_pointerPassthrough__uyTNn"};